import React from 'react';
import { useRoutes } from 'react-router-dom';

import OnboardingPage from './pages/Onboarding';
import { paths } from './util/constants';

const PublicRouter: React.FC = () => {
  const element = useRoutes([
    {
      path: `${paths.ONBOARDING}`,
      element: <OnboardingPage />,
    },
  ]);
  return element;
};

export default PublicRouter;
